import React from 'react';
import { COLORS } from 'pvs-design-system';

const HighlightText = ({ text, query }: { text?: string | null; query?: string }) => {
  const safeText = text ?? '';
  if (!query || !query.trim()) return <>{safeText}</>;
  const parts = safeText.split(new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={i} style={{ background: COLORS.sunshineYellow[400], color: COLORS.sunshineYellow[950], borderRadius: 2, padding: '0 2px' }}>
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </>
  );
};

export default HighlightText;
